import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Launch } from './pages/Launch';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
        <Route path="/launch" element={<Launch data-id="element-6" />} data-id="element-5" />
      </Routes>
    </BrowserRouter>;
}